import { render, staticRenderFns } from "./OrticSummernote.vue?vue&type=template&id=2c064e4e"
import script from "./OrticSummernote.vue?vue&type=script&lang=js"
export * from "./OrticSummernote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports